import React from 'react';

export const useCarouselState = (
    defaultActiveItem: number
): [number, (activeItem: number) => void] => React.useState(defaultActiveItem);
